import {UserAlertsError} from './UserAlertsError.js'

export class SearchHasNoFiltersUserAlertError extends UserAlertsError {
  constructor({notAvailableFilters, message, response}) {
    super(message)
    this._response = response
    this._errorData = response?.data
    this._notAvailableFilters = notAvailableFilters
  }

  getError = () => {
    return {
      notAvailableFilters: this._notAvailableFilters,
      message: this._message
    }
  }

  getErrorData = () => {
    return this._errorData
  }
}
